module.exports = __webpack_public_path__ + "img/logo-ebay.b6fed76b.png";